<template>
  <div>
    <title-row
      :title="page.title"
      :subtitle="page.subtitle"
      :breadcrumb-items="[
        {
          text: 'Adminisztátorok',
          to: { name: 'UserList' },
        },
        page.breadcrumbItem,
      ]"
    >
      <template #buttons>
        <title-row-button @click="impersonate">
          <v-icon left>mdi-domino-mask</v-icon>
          Megeszemélyesítés
        </title-row-button>
        <title-row-button @click="save" :loading="loading">
          <v-icon left>mdi-check</v-icon>
          Mentés
        </title-row-button>
      </template>
    </title-row>

    <loading-overlay v-if="loading" />

    <v-tabs v-model="tab" align-tabs="center" color="text--primary">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab key="general">Általános</v-tab>
      <v-tab key="filters">Szűrők</v-tab>

      <v-tabs-items class="pa-2" v-model="tab">
        <v-tab-item key="general">
          <v-row>
            <v-col :cols="12" :md="6">
              <v-card v-if="form.user.apiuser" class="rounded-xl" flat>
                <v-card-title><v-icon left>mdi-account</v-icon>Alapadatok</v-card-title>
                <v-card-text>
                  <v-masked-text-field
                    label="Név"
                    :error-messages="errors.name"
                    v-model="form.user.name"
                    :mask="$config.inputMasks.name"
                    filled
                  />
                  <v-masked-textarea
                    label="API kulcs"
                    :error-messages="errors.name"
                    v-model="form.user.apikey"
                    :mask="$config.inputMasks.name"
                    filled
                    rows="1"
                    auto-grow
                  />
                  <v-text-field
                    label="Lejárat dátuma"
                    readonly
                    v-model="form.user.apikey_expire"
                    filled
                  />
                </v-card-text>
              </v-card>
              <v-card v-else class="rounded-xl" flat>
                <v-card-title><v-icon left>mdi-account</v-icon>Alapadatok</v-card-title>
                <v-card-text>
                  <v-autocomplete
                    label="Címtáras keresés"
                    v-model="dnSelected"
                    :search-input.sync="dnSearchText"
                    :items="dnSearchItems"
                    item-text="text"
                    item-value="id"
                    :loading="dnLoading"
                    filled
                  />
                  <v-masked-text-field
                    label="Név"
                    :error-messages="errors.name"
                    v-model="form.user.name"
                    :mask="$config.inputMasks.name"
                    filled
                  />
                  <v-text-field
                    label="Email"
                    :error-messages="errors.email"
                    v-model="form.user.email"
                    filled
                  />
                  <v-masked-text-field
                    label="Jelszó"
                    :error-messages="errors.password"
                    v-model="form.user.password"
                    filled
                    :mask="$config.inputMasks.password"
                    :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPass ? 'text' : 'password'"
                    @click:append="showPass = !showPass"
                    autocomplete="new-password"
                  />
                  <v-masked-text-field
                    label="Jelszó Újra"
                    :error-messages="errors.password_"
                    v-model="form.user.password_"
                    filled
                    :mask="$config.inputMasks.password"
                    :append-icon="showPassAgain ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassAgain ? 'text' : 'password'"
                    @click:append="showPassAgain = !showPassAgain"
                    autocomplete="new-password"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col :cols="12" :md="6">
              <v-card class="rounded-xl" flat>
                <v-card-title><v-icon left>mdi-key-chain</v-icon>Engedélyek</v-card-title>
                <v-card-text>
                  <v-switch
                    label="QR kód beállítás fix 24 óra"
                    v-model="form.user.barcode_period_fix"
                  />
                  <v-select
                    filled
                    label="QR kód igénylés csoportok"
                    v-model="form.user.barcode_request_groups"
                    :items="usertype_groups"
                    item-text="name"
                    item-value="element_id"
                    multiple
                    chips
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item key="filters">
          <v-row>
            <v-col cols="12" lg="6">
              <v-card class="rounded-xl" flat>
                <v-card-title>
                  <v-icon left>mdi-shield-key-outline</v-icon>Jogosultságok
                </v-card-title>
                <v-card-text>
                  <v-alert v-if="errors.rights" type="error" dense>
                    {{ errors.rights[0] }}
                  </v-alert>
                  <v-treeview
                    ref="rightsTree"
                    :items="form.rights"
                    selection-type="leaf"
                    selectable
                    return-object
                    selected-color="primary"
                    v-model="selection"
                    shaped
                    transition
                    hoverable
                    multiple-active
                    dense
                    @input="rightsInputHandler"
                  >
                    <template v-slot:prepend="{ item, open }">
                      <v-icon>
                        {{
                          item.children
                            ? open
                              ? 'mdi-folder-open-outline'
                              : 'mdi-folder-key-outline'
                            : 'mdi-shield-key-outline'
                        }}
                      </v-icon>
                    </template>
                    <template v-slot:label="{ item }">
                      <span v-if="errors.rights && item.name == 'Kártya írás'" class="red">
                        {{ item.name }}
                      </span>
                      <span v-else>
                        {{ item.name }}
                      </span>
                      <span v-if="getRightDependencies(item.id)">
                        (Felülírja: {{ getRightDependencies(item.id) }})
                      </span>
                    </template>
                  </v-treeview>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" lg="6">
              <v-card class="rounded-xl" flat>
                <v-card-title><v-icon left>mdi-filter-variant</v-icon>Elem szűrők </v-card-title>
                <v-card-text>
                  <v-switch label="Csoportképzésnél szűrő" v-model="form.user.filter_element" />
                  <div v-if="form.user.filter_element" class="mt-6">
                    Szűrők
                    <template v-for="type in filter.element_types">
                      <v-autocomplete
                        :label="type.name"
                        :items="filter.elements[type.id]"
                        item-text="name"
                        item-value="element_id"
                        v-model="form.user.filter_elements[type.id]"
                        :value-comparator="$config.comparators.isEqual"
                        multiple
                        chips
                        return-object
                        filled
                      />
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>
<script>
import { debounce } from 'lodash';

export default {
  data() {
    return {
      tab: 'general',
      form: {
        user: {},
        rights: [],
      },
      filter: {
        elements: [],
        element_types: [],
      },
      dnLoading: false,
      dnSelected: {},
      dnSearchText: '',
      dnSearchItems: [],
      selection: [],
      errors: [],
      usertype_groups: [],
      loading: false,
      showPass: false,
      showPassAgain: false,
      userRights: [],
      isUpdatingElements: false,
    };
  },
  mounted() {
    this.fetchUser();
  },

  created() {
    this.debounceDnSearch = debounce(this.searchDn, 150);
  },

  methods: {
    async searchDn(search) {
      if (!search || search.length < 2) return;
      try {
        this.dnLoading = true;
        const response = await this.$http.post('users/dn-search', { search });
        this.dnSearchItems = response.items;
      } catch (e) {
        console.error(e);
      } finally {
        this.dnLoading = false;
      }
    },
    rightsInputHandler(items) {
      for (const item of items) {
        if (item.required_rights) {
          for (const right_id of item.required_rights) {
            const requiredRight = this.findRight('id', this.form.rights, right_id);
            if (requiredRight) {
              this.addRightToSelection(requiredRight);
            }
          }
        }
      }
    },
    getRightsSelection(items) {
      for (const item of items) {
        item.required_rights = JSON.parse(item.required_rights);
        if (item.selected) {
          this.selection.push(item);
        }
        if (item.children) {
          this.getRightsSelection(item.children);
        }
      }
    },
    addRightToSelection(right) {
      if (this.lodash.find(this.selection, { id: right.id })) {
        return;
      }
      this.selection.push(right);
    },
    findRight(key = 'id', rights, value) {
      let result = null;
      for (const right of rights) {
        if (right[key] == value) {
          result = right;
          break;
        }
        if (right.children) {
          result = this.findRight(key, right.children, value);
          if (result) {
            break;
          }
        }
      }
      return result;
    },
    getRightDependencies(id) {
      const dependencyOf = [];
      for (const item of this.selection) {
        if (item.required_rights && item.required_rights.includes(Number(id))) {
          dependencyOf.push(item);
        }
      }
      return dependencyOf.map((e) => e.name).join(', ');
    },
    addWildCardsToFilterElements(filter) {
      for (const type of filter.element_types) {
        if (!filter.elements[type.id]) {
          filter.elements[type.id] = [];
        }
        filter.elements[type.id].unshift({
          element_id: type.model_name,
          name: 'Minden ' + type.name.toLowerCase(),
        });
      }
    },
    normalizeFilterElements() {
      this.isUpdatingElements = true;
      try {
        for (const type of this.filter.element_types) {
          const elements = this.form.user.filter_elements[type.id] || [];

          if (elements.length === 0) {
            const wildcard = this.filter.elements[type.id]?.find(
              (e) => e.element_id === type.model_name
            );

            if (wildcard) {
              this.$set(this.form.user.filter_elements, type.id, [wildcard]);
            }
          } else if (elements.length > 1) {
            this.$set(
              this.form.user.filter_elements,
              type.id,
              elements.filter((e) => e.element_id !== type.model_name)
            );
          }
        }
      } finally {
        this.$nextTick(() => {
          this.isUpdatingElements = false;
        });
      }
    },
    async fetchUser() {
      try {
        this.loading = true;
        const response = await this.$http.get(`users/details/${this.$route.params.id || 0}`);
        if (response.user.dn_info.id != null) {
          this.dnSearchItems = [response.user.dn_info];
          this.dnSelected = response.user.dn_info.id;
        }
        if (!response.user.filter_elements || Array.isArray(response.user.filter_elements)) {
          response.user.filter_elements = {};
        }
        this.addWildCardsToFilterElements(response.filter);
        this.filter = response.filter;
        response.user.password_ = response.user.password;
        this.form.user = response.user;
        this.form.rights = response.rights;
        this.usertype_groups = response.usertype_groups;
        this.selection = [];
        this.getRightsSelection(this.form.rights);
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async save() {
      try {
        this.errors = {};
        this.loading = true;
        this.form.rights = this.selection;
        const response = await this.$http.post('users/save/', this.form);
        if (Object.keys(response.errors).length) {
          this.errors = response.errors;
          console.log(this.errors);
        } else {
          if (this.$route.name !== 'UserEditor') {
            this.$router.push({ name: 'UserEditor', params: { id: response.user.element_id } });
          }
          this.fetchUser();
          this.$dialog.notify.success('Sikeres mentés!');
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async impersonate() {
      const userId = this.$route.params.id;
      try {
        const response = await this.$http.post('users/impersonate', { user_id: userId });
        if (response.status == 'OK') {
          this.$store.commit('setImpersonate', userId);
          window.location.reload();
        }
      } catch (error) {
        console.error(error);
      }
    },
  },

  watch: {
    dnSearchText(newVal) {
      const selectedItem = this.dnSearchItems.find((item) => item.id === this.dnSelected);
      if (selectedItem && selectedItem.text === newVal) {
        return;
      }

      this.debounceDnSearch(newVal);
    },

    dnSelected(newVal) {
      const selectedItem = this.dnSearchItems.find((item) => item.id === newVal);
      if (selectedItem) {
        this.form.user.name = selectedItem.name;
        this.form.user.email = selectedItem.email;
      }
    },

    'form.user.filter_elements': {
      handler() {
        if (this.isUpdatingElements) return;
        this.normalizeFilterElements();
      },
      deep: true,
    },
  },

  computed: {
    page() {
      switch (this.$route.name) {
        case 'NewUser':
          return {
            isNew: true,
            title: 'Új adminisztrátor',
            breadcrumbItem: {
              text: 'Új adminisztrátor',
              disabled: true,
            },
          };
        case 'UserEditor':
          return {
            isNew: false,
            title: `Adminisztrátor: ${this.form.user.name ?? 'Betöltés...'}`,
            breadcrumbItem: {
              text: this.form.user.name,
              disabled: true,
            },
          };
      }
      return {};
    },
  },
};
</script>

<style lang="scss">
.v-treeview-node.v-treeview-node--shaped .v-treeview-node__root {
  margin: 0 !important;
}

.v-treeview-node__root {
  padding: 0 !important;
  min-height: 32px !important;
}
</style>
